import StockInfo from "../../models/StockInfo"

class StockInfoConverter {
    static convert(stockInfo) {
        return new StockInfo({ ...stockInfo });
    }
}

export default StockInfoConverter
